import Box from "@mui/material/Box";
import { DialogLeaveWarningContext } from "molecules/EdmDialog";
import { useContext } from "react";
import { SimpleForm, SimpleFormProps } from "react-admin";

import DefaultToolbar from "../../organisms/DefaultToolbar";

export default function SimpleBoxForm(props: SimpleFormProps) {
  const { children, toolbar = <DefaultToolbar />, ...formProps } = props;
  const { isInsideDialog } = useContext(DialogLeaveWarningContext);

  return (
    <SimpleForm warnWhenUnsavedChanges={!isInsideDialog} component={Box} toolbar={toolbar} {...formProps}>
      {children}
    </SimpleForm>
  );
}
